export default __webpack_public_path__ + "static/media/download.64037aba.svg";